import { brandConfig } from './brand.config'
import { envConfigForShare } from './envConfigForShare'
import { rewardsConfig } from './rewardsConfig'

/**
 * Server configuration that uses environment variables
 * All sensitive values are now loaded from process.env instead of being hardcoded
 */
const serverConfig = env => ({
  // Redis Configuration
  redisHost: process.env.REDIS_HOST,
  redisPort: process.env.REDIS_PORT,

  // Internal Service URLs
  communicationServiceUrl: process.env.COMMUNICATION_SERVICE_URL,
  rewardsServiceUrl: process.env.REWARDS_SERVICE_URL,
  authTokenServiceUrl: process.env.AUTH_TOKEN_SERVICE_URL,
  entityService: process.env.ENTITY_SERVICE_URL,
  healthUserServiceUrl: process.env.HEALTH_USER_SERVICE_URL,
  motorOrchestratorInternalUrl: process.env.MOTOR_ORCHESTRATOR_INTERNAL_URL,

  // Backend Service URLs
  fastagFetchBalance: process.env.FASTAG_FETCH_BALANCE_URL,
  fastagBiller: process.env.FASTAG_BILLER_URL,
  autoExternal: process.env.AUTO_EXTERNAL_URL,
  puc: process.env.PUC_SERVICE_URL,
  vehicleInfoService: process.env.VEHICLE_INFO_SERVICE_URL,
  autoAssetService: process.env.AUTO_ASSET_SERVICE_URL,
  ncsaAckodriveUrl: process.env.NCSA_ACKODRIVE_URL,

  // Admin URLs
  fireflyAdminUrl: process.env.FIREFLY_ADMIN_URL,

  // API Service
  apiService: process.env.API_SERVICE_URL,
  challanVas: process.env.CHALLAN_VAS_URL,

  // SendGrid API Key
  sg_acko_forbusiness: process.env.SG_ACKO_FORBUSINESS,

  // Ackodrive Client ID
  ackodriveClientId: process.env.ACKODRIVE_CLIENT_ID,
  appGeneratorLink: process.env.APP_GENERATOR_LINK,

  // Feature Configs (still use env-specific configs)
  rewardsConfig: rewardsConfig[env] || rewardsConfig.prod,
  brandConfig: brandConfig[env] || brandConfig.prod,
  shareConfig: envConfigForShare[env] || envConfigForShare.prod,

  teslaTestDriveBookingSheet: process.env.TESLA_TEST_DRIVE_SHEET_ID,

  // Abha
  abdmSaasJourneyManagerUrl: process.env.ABDM_SAAS_JOURNEY_MANAGER_URL,
  healthAckoAbdmServiceUrl: process.env.HEALTH_ACKO_ABDM_SERVICE_URL,
  healthJourneyManagementServiceUrl: process.env.HEALTH_JOURNEY_MANAGEMENT_SERVICE_URL,
})

export const getServerConfig = env => serverConfig(env)
